import BorderColor from "../ConfigParameters/BorderColor";
import BorderWidth from "../ConfigParameters/BorderWidth";
import BorderRadius from "../ConfigParameters/BorderRadius";
import BorderStyle from "../ConfigParameters/BorderStyle";
import { gettext } from "../ConfigParameter";

export default class Borders {

    constructor(defaultBorderColor = '#cbcbcb') {
        let borderRadius = new BorderRadius();
        borderRadius.setLabel(gettext('Border radius'));
        borderRadius.setGroup('borders');

        let borderColor = new BorderColor();
        borderColor.setDefaultValue(defaultBorderColor);

        return {
            ...(borderColor),
            ...(new BorderWidth()),
            ...(new BorderRadius()),
            ...(new BorderStyle()),
        };
    }

}


// WEBPACK FOOTER //
// ./src/cmsCore/Creator/ConfigParameters/ConfigCollections/Borders.js